import { render, staticRenderFns } from "./qualificacaoTecnica.vue?vue&type=template&id=2f4547dc&scoped=true"
import script from "./qualificacaoTecnica.vue?vue&type=script&lang=js"
export * from "./qualificacaoTecnica.vue?vue&type=script&lang=js"
import style0 from "./qualificacaoTecnica.vue?vue&type=style&index=0&id=2f4547dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4547dc",
  null
  
)

export default component.exports